<div class="max-w-full overflow-y-auto">
    <div class="mb-4 bg-white shadow-md md:hidden">
        <p class="p-4 text-left text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow">
            {{ 'SELECT_MEDIA' | translate }}
        </p>
    </div>
    <div class="mb-6 hidden py-2 md:block">
        <p class="text-left text-base font-bold leading-4">
            {{ 'SELECT_MEDIA' | translate }}
        </p>
    </div>
    <div
        class="mb-4 h-full w-auto rounded-lg bg-transparent px-2 dark:bg-contrast-black md:bg-grey-white_smoke md:p-4"
        *ngIf="isLogin">
        <div class="bg-white p-2 md:p-4">
            <p
                class="text-xs font-semibold leading-4 tracking-wider text-grey-dark dark:text-contrast-yellow md:leading-5">
                {{ 'SAVED_FARE_MEDIA' | translate | uppercase }}
            </p>
            <div class="mt-2 border border-solid border-opacity-5 dark:border-contrast-yellow md:mt-4"></div>
        </div>
        <div
            class="mb-0 box-border grid max-h-screen w-full overflow-y-auto bg-white p-4 md:max-h-full md:gap-4"
            [ngClass]="hasSavedPreferences() ? 'md:grid-cols-2' : 'grid-cols-1'">
            <div class="col-span-full w-full pb-4 text-left text-black" *ngIf="!hasSavedPreferences()">
                {{ 'NO_SAVED_MEDIA_AVAILABLE' | translate }}
            </div>
            <ng-container *ngIf="hasSavedPreferences()">
                <button
                    class="box-border flex w-full items-center justify-between gap-2 border-b border-solid border-black border-opacity-10 bg-white p-2 shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),_0px_0px_4px_-1px_rgba(0,0,0,0.06)] md:gap-4 md:rounded-lg md:border-0 md:p-4"
                    *ngFor="let preference of preferences; let index = index"
                    (click)="selectPreference(preference.id)">
                    <div class="flex w-52 flex-row text-left md:block">
                        <ion-icon
                            class="tallinn-light:text-secondary gl-light:text-secondary h-8 w-8 flex-shrink-0 pr-1 text-primary dark:text-contrast-yellow md:h-16 md:w-16 md:pr-0"
                            alt="icon-preference-email"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/preferences/icon-{{
                                preference.code.toLowerCase()
                            }}.svg"></ion-icon>
                        <div class="min-w-0 flex-1">
                            <h6 class="break-words text-base font-bold leading-7 text-black dark:text-contrast-yellow">
                                {{ preference.name }}
                            </h6>
                            <p
                                class="text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
                                *ngIf="preference.description">
                                {{ preference.description }}
                            </p>
                            <p
                                class="text-xs font-semibold text-secondary dark:text-contrast-yellow"
                                *ngIf="env.PURCHASE_FLOW?.PREFERENCES_LABEL_ENABLED">
                                {{
                                    (preference.code === TravelMedia.card ? 'MEDIA_CARD_LABEL' : 'MEDIA_EMAIL_LABEL')
                                        | translate
                                        | uppercase
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center p-3">
                        <ion-icon class="mr-2" aria-hidden="true" name="chevron-forward-outline"></ion-icon>
                    </div>
                </button>
            </ng-container>
        </div>
        <div class="full-width flex-justify-center flex flex-col items-center py-7">
            <ion-button
                class="text-base font-semibold normal-case leading-4"
                [routerLink]="
                    env?.PURCHASE_FLOW?.PREFERENCES_OLD_ADD_TRAVEL_CARD_LINK
                        ? ('/account/related-cards/add' | localize)
                        : ('/account/cards/add' | localize)
                "
                color="secondary"
                fill="clear">
                <ion-icon class="mr-3.5 h-7 w-7" name="add"></ion-icon>
                {{ 'ADD_TRAVEL_CARD' | translate }}</ion-button
            >
            <span
                class="flex cursor-pointer items-center justify-center gap-2 text-sm font-bold"
                *ngIf="env.PURCHASE_FLOW?.SAVE_PREFERENCE_ENABLED"
                (click)="savePreferenceHandler()">
                <ion-checkbox [checked]="savedPreferenceCheckbox" mode="md" slot="start"></ion-checkbox>
                <ion-label class="ml-0 inline">
                    {{ 'REMEMBER_CHOICE_FUTURE_PURCHASES' | translate }}
                </ion-label>
            </span>
        </div>
    </div>
    <div class="h-full w-auto rounded-lg bg-transparent px-2 dark:bg-contrast-black md:bg-grey-white_smoke md:p-4">
        <div class="w-auto rounded-lg bg-grey-white_smoke">
            <div class="w-auto bg-white">
                <div class="mb-4 px-2 pb-4 pt-2 md:px-4 md:pb-5 md:pt-4">
                    <p
                        class="mb-4 text-xs font-semibold leading-5 tracking-wider text-grey-dark dark:text-contrast-yellow">
                        {{ 'OTHER_FARE_MEDIA' | translate | uppercase }}
                    </p>
                    <div>
                        <div class="flex rounded-lg bg-grey-white_smoke dark:bg-contrast-black">
                            <button
                                class="m-0 flex h-11 flex-1 items-center justify-center rounded-lg text-center normal-case"
                                *ngFor="let option of options"
                                [ngClass]="
                                    option === selectedOption
                                        ? 'bg-white font-semibold text-black shadow-[0px_2px_6px_rgba(0,0,0,0.1),0px_0px_4px_rgba(0,0,0,0.06)] dark:border-contrast-black dark:bg-contrast-yellow dark:text-contrast-black'
                                        : 'font-bold text-[#5e5e5e] dark:text-contrast-yellow'
                                "
                                (click)="addOtherFareMedia(option)">
                                {{ option.toString() | translate }}
                            </button>
                        </div>
                        <div
                            class="tartu-light:text-white tartu-light:bg-black tallinn-light:bg-secondary-background tallinn-light:text-black bg-grey-catskill_white mt-5 flex rounded-lg px-2.5 py-2">
                            <ion-icon
                                class="align-self-center mr-2 min-h-[2.25rem] min-w-[2.25rem]"
                                src="{{
                                    assetsPath$ | async
                                }}/img/purchase-flow-v2/preferences/info-icon-outline.svg"></ion-icon>

                            <p class="align-self-center whitespace-pre-line leading-5">
                                {{
                                    (combinedCodeCard && selectedOption === 'CARD'
                                        ? 'PERSONALCODE_TRAVELCARD_DESC'
                                        : selectedOption + '_DESC'
                                    ) | translate
                                }}
                            </p>
                        </div>
                        <div class="mt-3 flex justify-end" *ngIf="selectedOption === 'BANK_CARD'">
                            <ion-button
                                class="login-web-button w-32 lg:w-64"
                                [attr.aria-label]="'BTN_LOG_IN' | translate"
                                (click)="navigateToLogin()"
                                type="submit"
                                size="large"
                                color="secondary">
                                <ion-label class="text-base font-semibold normal-case">
                                    {{ 'BTN_LOG_IN' | translate }}
                                </ion-label>
                            </ion-button>
                        </div>
                        <div class="mt-6" *ngIf="selectedOption !== 'BANK_CARD'">
                            <form [formGroup]="otherFareMediaForm">
                                <div class="flex flex-col" formControlNameSelector="otherFareMedia">
                                    <mat-form-field class="w-full dark:bg-contrast-black" appearance="outline">
                                        <mat-label>
                                            {{
                                                combinedCodeCard && selectedOption === 'CARD'
                                                    ? ('CARD_NUMBER' | translate)
                                                    : selectedOption === 'EMAIL'
                                                      ? ('PH_EMAIL' | translate)
                                                      : (selectedOption?.toString() | translate)
                                            }}
                                        </mat-label>
                                        <input
                                            [type]="selectedOption === 'EMAIL' ? 'email' : 'text'"
                                            (input)="onInputChange($event)"
                                            formControlName="otherFareMedia"
                                            required
                                            matInput />
                                    </mat-form-field>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
